function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".filler{fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "paper");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "layer1"
}, /*#__PURE__*/React.createElement("path", {
  id: "path32665",
  className: "filler",
  d: "M3,2.5a.5.5,0,0,0-.5.5V29a.5.5,0,0,0,.5.5H25a.5.5,0,0,0,.5-.5V19.25a.5.5,0,1,0-1,0h0V28.5H3.5V3.5H19.27L24.5,9.68V12a.5.5,0,1,0,1,0h0V9.5a.47.47,0,0,0-.12-.32l-5.5-6.5a.49.49,0,0,0-.38-.18Z",
  transform: "translate(-2.5 -2.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path32667",
  className: "cls-10",
  d: "M19.49,2.5A.5.5,0,0,0,19,3h0V9.5a.5.5,0,0,0,.5.5H25a.5.5,0,0,0,0-1H20V3a.5.5,0,0,0-.49-.51Z",
  transform: "translate(-2.5 -2.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path32669",
  className: "filler",
  d: "M26.79,12.5a.47.47,0,0,0-.35.15L18.12,21a.45.45,0,0,0-.11.17l-1.47,3.67a.49.49,0,0,0,.27.65.5.5,0,0,0,.38,0L20.86,24a.45.45,0,0,0,.17-.11l8.32-8.32a.5.5,0,0,0,0-.71l-2.2-2.2A.51.51,0,0,0,26.79,12.5Zm0,1.21,1.5,1.5-7.9,7.9-2.5,1,1-2.49Z",
  transform: "translate(-2.5 -2.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path32671",
  className: "filler",
  d: "M18.71,21.07a.5.5,0,0,0-.5.5.51.51,0,0,0,.15.36l1.71,1.71a.5.5,0,0,0,.71,0,.49.49,0,0,0,0-.7l0,0-1.71-1.71a.51.51,0,0,0-.36-.15Z",
  transform: "translate(-2.5 -2.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path32673",
  className: "filler",
  d: "M6.51,12a.5.5,0,0,0,0,1h5.76a.5.5,0,1,0,0-1H6.51Z",
  transform: "translate(-2.5 -2.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path32675",
  className: "filler",
  d: "M14,12a.5.5,0,0,0-.5.49A.49.49,0,0,0,14,13h1a.5.5,0,1,0,0-1H14Z",
  transform: "translate(-2.5 -2.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path32677",
  className: "filler",
  d: "M16.76,12a.5.5,0,0,0-.5.49.49.49,0,0,0,.49.51H19.5a.5.5,0,1,0,0-1H16.76Z",
  transform: "translate(-2.5 -2.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path32679",
  className: "filler",
  d: "M11.76,15.5a.5.5,0,0,0-.5.49.49.49,0,0,0,.49.51H19.5a.5.5,0,1,0,0-1H11.76Z",
  transform: "translate(-2.5 -2.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path32681",
  className: "filler",
  d: "M8,15.5a.5.5,0,0,0-.5.49A.49.49,0,0,0,8,16.5h2a.5.5,0,1,0,0-1H8Z",
  transform: "translate(-2.5 -2.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path32683",
  className: "filler",
  d: "M6.25,15.5a.5.5,0,1,0,0,1h.27A.5.5,0,0,0,7,16a.49.49,0,0,0-.49-.51H6.25Z",
  transform: "translate(-2.5 -2.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path32685",
  className: "filler",
  d: "M6.51,19a.5.5,0,0,0,0,1h3.76a.5.5,0,1,0,0-1H6.51Z",
  transform: "translate(-2.5 -2.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path32687",
  className: "filler",
  d: "M12,19a.5.5,0,0,0-.5.49A.49.49,0,0,0,12,20h1a.5.5,0,1,0,0-1H12Z",
  transform: "translate(-2.5 -2.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path32689",
  className: "filler",
  d: "M9.51,22.5a.5.5,0,0,0,0,1H13a.5.5,0,1,0,0-1H9.51Z",
  transform: "translate(-2.5 -2.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path32691",
  className: "filler",
  d: "M6.51,22.5a.5.5,0,0,0,0,1H7.74a.5.5,0,1,0,0-1H6.51Z",
  transform: "translate(-2.5 -2.5)"
}));

var SvgPaper = function SvgPaper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paper.a28e551e.svg";
export { ForwardRef as ReactComponent };